(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bss-editorial-collection-rail"] && !Shopify.designMode) return;
  try {
    
(() => {
  document.querySelectorAll('[data-bss-editorial-rail]').forEach((section) => {
    if (section.dataset.bound === '1') return;
    section.dataset.bound = '1';
    const track = section.querySelector('[data-er-track]');
    const prev = section.querySelector('[data-er-prev]');
    const next = section.querySelector('[data-er-next]');
    const progress = section.querySelector('[data-er-progress]');
    if (!track) return;
    const step = () => {
      const card = track.querySelector('.bss-er__card');
      if (!card) return 320;
      const style = getComputedStyle(track);
      return card.getBoundingClientRect().width + parseFloat(style.gap || 0);
    };
    const update = () => {
      const max = Math.max(track.scrollWidth - track.clientWidth, 1);
      const ratio = Math.min(Math.max(track.scrollLeft / max, 0), 1);
      if (progress) progress.style.setProperty('--er-progress', (18 + ratio * 82) + '%');
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
    };
    if (prev) prev.addEventListener('click', () => track.scrollBy({left:-step(),behavior:'smooth'}));
    if (next) next.addEventListener('click', () => track.scrollBy({left:step(),behavior:'smooth'}));
    track.addEventListener('scroll', update, {passive:true});
    window.addEventListener('resize', update);
    update();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
